import React from 'react';
import { FeatureCard } from './FeatureCard';
import TrendingIcon from '../../../icons/TrendingIcon';
import FeaturedRoundIcon from '../../../icons/FeaturedRoundIcon';
import BriefcaseRoundIcon from '../../../icons/BriefcaseRoundIcon';
import TrendingRoundIcon from '../../../icons/TrendingRoundIcon';

export const FeaturesSection = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-[24px]">
      <FeatureCard
        icon={<FeaturedRoundIcon className="w-10 h-10" />}
        title="Smart Hiring Dashboard"
        description="Manage applications and shortlist candidates with smart dashboards and insights."
      />

      <FeatureCard
        icon={<BriefcaseRoundIcon className="w-10 h-10" />}
        title="Hire smarter with AI-matching"
        description="See top-fit candidates manage your hiring pipeline with AI-driven recommendations."
      />

      <FeatureCard
        icon={<TrendingRoundIcon className="w-10 h-10" />}
        title="Automated Candidate Screening"
        description="Discover qualified talent in seconds with custom screening questions."
      />
    </div>
  );
};
